export default __webpack_public_path__ + "static/media/route-gestalt.ff1ff5d6.svg";